<div class="ui container" appMargin appPadding paddingB='30'>


    <div class='ui vertical basic segment' [ngClass]="{'loading':pending}">
        <div fxLayout="row" fxLayoutAlign='space-between center'>
            <div fxLayoutAlign='start center' fxLayout='row' fxLayoutGap='20px' (click)="goBack()" class="link">
                <div >
                    <img src="assets/icons/left-arrow-icon.svg" alt="">
                </div>
                <div class='equipment-id'>
					<!-- Title -->
                    <h2 class="ui primary header">Add New Role</h2>
                </div>
            </div>

              <div fxLayout='row' fxLayoutGap='15px'>

					<button class="ui basic small  primary  button" (click)="goBack()" suiPopup [popupInverted]="true" popupPlacement="bottom" popupText="cancel role">
						Cancel
						</button>

					<button class="ui small  primary  button" suiPopup [popupInverted]="true" popupPlacement="bottom" popupText="create role">
						Create Role
						</button>
					</div>

		</div>
		<div class="ui divider" appMargin marginY="3"></div>
    <div *ngIf="success || error">
      <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>

    </div>

		<div fxLayout="row" fxLayoutGap='50px'>
            <div fxFlex="25%">
				<div class="ui form side-panel" appPadding="15px">

					<div class="field" appMargin marginB="10">
						<label>ROLE TITLE</label>
						<h3 appMargin="0px" class="ui primary header">{{role?.roleName}}</h3>
					</div>
					<div class="field" appMargin marginB="10">
						<label>DESCRIPTION</label>
						{{role?.roleDescription}}
                    </div>
                    <div class="field" appMargin marginB="10">
						<label>DATE CREATED</label>
					17 Oct, 2020
                    </div>
                    		<div class="field" appMargin marginB="10">
						<label>CREATED BY</label>
					Tife Balogun
                    </div>
                    		<div class="field " appMargin marginB="10">
						<label>LAST EDITED</label>
						8 Sep, 2020
                    </div>
                    <div class="field" appMargin marginB="10">
						<label>EDITED BY</label>
					Kelechi Nwosu
					</div>
                </div>
            </div>
				<div fxFlex="grow">
						<div class="ui segment">
								<div appPadding paddingB="15px">
                    <div fxLayout="row">
                        <div fxFlex="grow"></div>
                        <div fxFlex="10%">READ</div>
                         <div fxFlex="10%">CREATE</div>
                         <div fxFlex="10%">EDIT</div>
                         <div fxFlex="10%">DELETE</div>
                    </div>

                    <div class="ui divider"></div>

                       <ng-template ngFor let-permission [ngForOf]="selectedRolePermissions" let-i="index">
                                <div fxLayout="column" *ngIf="permission.key && i == 0 " >
                                  <div>
                                   <strong> {{permission?.key | uppercase}} </strong>
                                  </div>
                                <div class="ui divider"></div>
                                </div>
                                     <div fxLayout="column" *ngIf="permission.key && i != 0 " appMargin marginT="15">
                                  <div>
                                   <strong> {{permission?.key | uppercase}} </strong>
                                  </div>
                                <div class="ui divider"></div>
                                </div>
                                <div fxLayout="row" *ngFor="let perm of permission.value" appMargin marginB="7">
                                  <div fxFlex="grow">
                                    {{perm?.permissionDesc}}
                                  </div>

                                  <div fxFlex="10%">
                                      <!-- <sui-checkbox
                                      [(ngModel)]="perm.read" >
                                       </sui-checkbox> -->
                                    <input [checked]="perm.read === checkOptions[0].value" [value]="perm.read"
                                      name="read" type="checkbox">
                                  </div>

                                  <div fxFlex="10%">
                                    <input [checked]="perm.add === checkOptions[0].value" [value]="perm.add"
                                      name="add" type="checkbox">
                                  </div>

                                  <div fxFlex="10%">
                                    <input [checked]="perm.edit === checkOptions[0].value" [value]="perm.edit"
                                      name="edit" type="checkbox" >
                                  </div>

                                  <div fxFlex="10%">
                                    <input [checked]="perm.remove === checkOptions[0].value" [value]="perm.remove"
                                      name="remove" type="checkbox">
                                  </div>
                                </div>
                            </ng-template>
                <!-- <form #f="ngForm" novalidate>
                    <table *ngIf="selectedRolePermissions" class="ui striped table">
                        <thead class="thin-border-bottom">
                            <tr>
                                <th>
                                PERMISSION
                                </th>

                                <th>
                                    READ
                                </th>
                                <th>
                                    CREATE
                                </th>
                                <th>
                                EDIT
                                </th>
                                <th>
                                    DELETE
                                </th>
                            </tr>
                        </thead>
                        <tbody>

                        </tbody>
                    </table>
                </form> -->
		</div>

						</div>

				</div>
			</div>

</div>
